import "./ControllerInstructions.css";
import React, {PropsWithChildren} from "react";

interface Props {
  visible: boolean;
}

export const ControllerInstructions = ({visible, children}: PropsWithChildren<Props>) => {
  if (!visible) {
    return null;
  }
  return <div className="controller-instructions">{children}</div>;
};
